import React from 'react'
import PropTypes from 'prop-types'
import ClassDrawerHeaderLayout, {
  ContentWrapper,
  TitleWrapper,
} from '../Layout'
import {
  ClassInfoText,
  ClassTitle,
  LessonsComplete,
  ProgressContainer,
  ProgressSection,
  StyledProgressBar,
} from './component.styles'
import { BHU_TITLE, UNIT_1_4_TITLE } from './constants'

/**
 * Reports context header for class drawer.
 * Core view: primary title + core lesson progress. BHU view: BHU title + RBHU lesson progress only.
 */
const ReportsClassHeader = ({
  bhuLessons,
  classTitle,
  fixedTop,
  fixedView,
  gradeName,
  hasBHU,
  lessonCount,
  lessonsCompleted,
  primaryProgressSectionTitle = UNIT_1_4_TITLE,
  teacherFirstName,
  teacherLastName,
}) => {
  const bhuLessonsMarkedDone =
    bhuLessons?.filter(lesson => lesson.completedDate !== null).length || 0

  let lessonsCount = 0
  let lessonsMarkedDone = 0
  let percentComplete = 0
  let lessonsCompleteText = ''
  let progressSectionTitle = primaryProgressSectionTitle

  if (hasBHU) {
    lessonsCount = bhuLessons?.length || 0
    lessonsMarkedDone = bhuLessonsMarkedDone
    percentComplete = Math.floor(
      lessonsCount > 0 ? (lessonsMarkedDone / lessonsCount) * 100 : 0,
    )
    lessonsCompleteText = `${lessonsMarkedDone} of ${lessonsCount} lessons marked done`
    progressSectionTitle = BHU_TITLE
  } else {
    lessonsCount = lessonCount
    lessonsMarkedDone = lessonsCompleted - bhuLessonsMarkedDone
    percentComplete = Math.floor(
      lessonsCount > 0 ? (lessonsMarkedDone / lessonsCount) * 100 : 0,
    )
    lessonsCompleteText = `${lessonsMarkedDone} of ${lessonsCount} lessons marked done`
  }

  const classHeaderTitle = `Class: ${classTitle}`
  const learnerGradeText = `${teacherFirstName} ${teacherLastName} • ${gradeName}`
  const fixedViewLearnerGradeText = `Class: ${classTitle} • ${learnerGradeText}`
  const classInfoText = fixedView ? fixedViewLearnerGradeText : learnerGradeText

  return (
    <ClassDrawerHeaderLayout fixedTop={fixedTop} fixedView={fixedView}>
      <ContentWrapper>
        <TitleWrapper>
          {!fixedView && (
            <ClassTitle dataTestId="class-title">{classHeaderTitle}</ClassTitle>
          )}
          <ClassInfoText data-testid="class-info-text">
            {classInfoText}
          </ClassInfoText>
        </TitleWrapper>
      </ContentWrapper>
      <ProgressContainer>
        <ProgressSection>
          {progressSectionTitle}
          {!fixedView && (
            <StyledProgressBar
              dataTestId="class-progress-bar"
              percentComplete={percentComplete}
            />
          )}
          <LessonsComplete data-testid="lessons-complete">
            {lessonsCompleteText}
          </LessonsComplete>
        </ProgressSection>
      </ProgressContainer>
    </ClassDrawerHeaderLayout>
  )
}

ReportsClassHeader.propTypes = {
  bhuLessons: PropTypes.array,
  classTitle: PropTypes.string,
  fixedTop: PropTypes.bool,
  fixedView: PropTypes.bool,
  gradeName: PropTypes.string,
  hasBHU: PropTypes.bool,
  lessonCount: PropTypes.number,
  lessonsCompleted: PropTypes.number,
  primaryProgressSectionTitle: PropTypes.string,
  teacherFirstName: PropTypes.string,
  teacherLastName: PropTypes.string,
}

export default ReportsClassHeader
